export default "__VITE_ASSET__qMRbWO$5__"